<template>
 <div >
   <b-container fluid class="slide-bg" >

     
   <b-row   style="height:300px;width:90%">
     <b-col  lg="4" sm="12" md="12" align-content="center" >
     </b-col>
     <b-col  lg="4" sm="12" md="12" align-content="center" >
  
                            <img :src='"../assets/images/logo7year.png"' alt="top3" style="width:90%;height:auto; animation: moveleftbounce 2.1s linear infinite;" class="ml-2"  >
       
      </b-col>
      <b-col  lg="4" sm="12" md="12" align-content="center" >
     </b-col>
    
  </b-row> 
</b-container>

   <b-container center align-h="center" class="m-5">
   <b-row style="width:80%;" align-h="center" class="mt-3 center">
    <b-col col="6">
      
   <!--  -->
 <p>
        <b-form-group label="ข้อความแสดงความยินดี :">
          <b-form-textarea
      id="textarea"
      v-model="text"
      placeholder="ข้อความแสดงความยินดี"
      rows="4"
      max-rows="4"
    ></b-form-textarea>
         </b-form-group>
     <b-form-group label="ชื่อ-นามสกุล :">
    <b-form-input v-model="author" placeholder="พิมพ์ชื่อ"></b-form-input>
      </b-form-group> <!--  <b-form-group label="ตำแหน่ง">
    <b-form-input v-model="position" placeholder="พิมพ์ตำแหน่ง"></b-form-input>
    </b-form-group> -->  <b-form-group label="จากหน่วยงาน : ">
    <b-form-input v-model="org" placeholder="พิมพ์หน่วยงาน"></b-form-input>
    </b-form-group>  
     <b-form-checkbox
      id="checkbox-1"
      v-model="status"
      name="checkbox-1"
      value="donate"
      unchecked-value="not_donate"
    >
      ร่วมบริจาค 
    </b-form-checkbox>

    <div v-if="status == 'donate'">
      <p>โดยบริจาคเงินเข้าบัญชีธนาคารกรุงไทย สาขาบางขุนนท์ ชื่อบัญชีการยางแห่งประเทศไทย 058-038679-1</p>
       <p><img   src="../assets/images/qrcode.jpg"  style="width: 100%;max-width: 200px;height: auto;"></p>
       
      <b-form-group label="ยอดที่บริจาค (ตัวเลข) *  :">
    <b-form-input v-model="total_donate" placeholder="ยอดที่บริจาค" type="number"></b-form-input>
      </b-form-group>   
       <b-form-group label="ที่อยู่สำหรับจัดส่งใบเสร็จ * :">
              <b-form-textarea
      id="textarea"
      v-model="address"
      placeholder="ใส่ที่อยู่"
      rows="3"
      max-rows="6"
    ></b-form-textarea>
         </b-form-group> 

 <b-form-group label="สลิปการโอนเงิน*">

           <div class="file-upload-form">
         <span style="color:red" v-if="slip_donate == ''">ต้องแนบไฟล์สลิปการโอน กรณีร่วมบริจาค</span>
               <input type="file" @change="previewImage" accept="image/*">
            </div>
            <div class="image-preview" v-if="slip_donate.length > 0">
                <img class="preview" :src="slip_donate" style="  max-width: 60%;
  height: auto;">
            </div>

 </b-form-group>
    
     
    </div>
   
  
   
    <b-button class='mb-5' size="lg" variant="outline-success" block  disabled v-if="text == '' || author == ''  || org == '' ">ส่งข้อความร่วมแสดงความยินดี</b-button> 
    <b-button class='mb-5' v-else-if="status=='not_donate'" size="lg" variant="success" block @click="saveCelebrate()"  >ส่งข้อความร่วมแสดงความยินดี</b-button>
   <b-button class='mb-5' v-else-if="total_donate == ''  || address == '' || slip_donate == ''" size="lg" variant="success" block disabled @click="saveCelebrate()"  >ส่งข้อความและร่วมบริจาค</b-button>
    <b-button class='mb-5' v-else-if="total_donate != ''  || address != '' || slip_donate != '' || status=='donate'" size="lg" variant="success" block @click="saveCelebrate()"  >ส่งข้อความและร่วมบริจาค</b-button>
    
  
   <!--  -->
     
    
    </b-col>
    
  </b-row>
</b-container>

  </div>
</template>

<script>
/*   import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css' */
  import axios from 'axios';
  export default {
    name: 'swiper-example-3d-coverflow',
    title: '3D Coverflow effect',
    components: {
  /*     Swiper,
      SwiperSlide */
    },
    data() {
    
      return {
        countword: 0,
         cardData: [],
            text: '',
      lineTxt: [],
      author: '',
      title: 'ขอขอบคุณที่ร่วมแสดงความยินดี',
      org: '',
      position: '',
      name_donate: '',
      status: 'not_donate',
      total_donate: '',
      address: '',
      slip_donate: '',
      text_tmp: '',
      author_tmp: '',
      org_tmp: '',
      position_tmp: '',
      name_donate_tmp: '',
      status_tmp: 'not_donate',
      total_donate_tmp: '',
      address_tmp: '',
      slip_donate_tmp: '',
output: '',
         swiperOption: {
          effect: 'coverflow',
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          keyboardControl: true,
          loop: true,
          autoplay: {
                        delay: 2000,
                        disableOnInteraction: true
                    },
          speed: 800,
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows : true
          },
          pagination: {
            el: '.swiper-pagination'
          }
        }
        
      }
    },
    mounted() {
      
   
    },
    methods: {
      
    closeProgramModal() {
       
        this.$bvModal.hide('show-program')
    },
    closeAreaModal() {
       
        this.$bvModal.hide('show-area')
    },
      async print() {
      const el = this.$refs.printMe;
      // add option type to get the image version
      // if not provided the promise will return 
      // the canvas.
      const options = {
        type: 'dataURL'
      }
      this.output = await this.$html2canvas(el, options);
      console.log(this.output)
        var dlnk = document.getElementById('dwnldLnk');
    dlnk.href = this.output;

    dlnk.click();
    this.$bvModal.hide('show_card')
    this.clearInputCard()

    },
      async loadCard () {
         try{
      let res = await axios.get('https://youngcyber.xyz/celebrate-api/index.php/celebrate/show')
  
      this.cardData = [];
      this.cardData = res.data
        
    }catch(err){
      console.log(err)
    }
      
      },
 showMsgBox() {
    this.countword = this.text_tmp.length

    
   this.$bvModal.show('show_card')
    // this.$bvModal.msgBoxConfirm('ขอเชิญรวมบริจาคเงิน เพื่อสมทบกองทุนเพื่อผู้ป่วยยากไร้ ของศิริราชมูลนิธิ โรงพยายาบาลศิริราช และกิจกรรมเพื่อการกุศลอื่นๆ', {
    //       title: 'ส่งบัตรอวยพรสำเร็จ',
    //       size: 'sm',
    //       buttonSize: 'sm',
    //       okVariant: 'success',
    //       okTitle: 'สนใจบริจาค',
    //       cancelTitle: 'ไม่เป็นไร',
    //       footerClass: 'p-2',
    //       hideHeaderClose: false,
    //       centered: true
    //     })
    //       .then(value => {
    //         this.$root.$emit('bv::toggle::sidebar', 'sidebar-transfer')
    //         sidebar-transfer
    //            this.clearInputCard()
    //          this.loadCard()
    //       })
    //       .catch(err => {
    //            this.clearInputCard()
    //          this.loadCard()
    //       })



      
          
      },
      saveCelebrate() {

        if(this.status == 'not_donate'){
          this.title = "ขอขอบคุณที่ร่วมแสดงความยินดี"
        }else {
          this.title = "ขอขอบคุณที่ร่วมแสดงความยินดีและร่วมบริจาค"
        }

      let formData = new FormData();

      formData.append('text', this.text);
      formData.append('author', this.author);
      formData.append('position', this.position);
      formData.append('org', this.org);
      formData.append('image', 'aaaaas.png');
      formData.append('image_data', this.dataURL);
      formData.append('status_donate', this.status);
      formData.append('total_donate', this.total_donate);
      formData.append('address', this.address);
      formData.append('slip_donate', this.slip_donate);
      
            axios.post( 'https://youngcyber.xyz/celebrate-api/index.php/celebrate/addwithdonate',
                 formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
              }
            ).then(function(){
        
          console.log('SUCCESS!!');
        })
        .catch(function(){
          console.log('FAILURE!!');
        });
          this.$bvToast.toast(this.title, {
          title: `ได้บันทึกข้อมูลเรียบร้อยแล้ว`,
          toaster: 'b-toaster-top-center',
          variant: 'success',
          solid: true
        })
    
          this.clearInputCard();
      //   this.showMsgBox()
        //this.$bvModal.show('modal-save')
        
    },
    clearInputCard(){
      this.text_tmp = this.text,
      this.author_tmp = this.author,
      this.org_tmp = this.org,
      this.position_tmp = this.position,
      this.name_donate_tmp = this.name_donate,
      this.status_tmp = this.status,
      this.total_donate_tmp = this.total_donate,
      this.address_tmp = this.address,
      this.slip_donate_tmp = this.slip_donate,
        this.text = ''
        this.author = ''
        this.org = ''
        this.position = ''
        this.name_donate = ''
        this.total_donate = ''
        this.address = ''
        this.slip_donate = ''
        this.status = 'not_donate'

  
    }
     ,
 showMsgBoxDonate() {
       this.$bvModal.msgBoxOk('ได้ส่งข้อมูลบริจาคของคุณเรียบร้อยแล้ว', {
          title: 'ส่งข้อมูลบริจาคสำเร็จ',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
          .then(value => {
            
            this.clearInputCard()
             this.loadCard()
          })
          .catch(err => {
            // An error occurred
          })
          
      },
      saveDonate() {

      let formDonateData = new FormData();

     // formDonateData.append('name_donate', this.name_donate);
      formDonateData.append('total_donate', this.total_donate);
      formDonateData.append('address', this.address);
      formDonateData.append('slip_donate', this.slip_donate);
      

            axios.post('http://httapi.xyz/celebrate-api/index.php/donate/addwith',
                 formDonateData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
              }
            ).then(function(){
         
          console.log('SUCCESS!!');
        })
        .catch(function(){
          console.log('FAILURE!!');
        });

         this.showMsgBoxDonate()
       
        
    },
    previewImage (event) {
            var input = event.target;
            this.status = 'donate'
            
            if (input.files && input.files[0]) {
  
                var reader = new FileReader();
                
                reader.onload = (e) => {
                   
                    this.slip_donate = e.target.result;
                }
                
                reader.readAsDataURL(input.files[0]);
            }
        }

    },
    wrapText (str) {
       let newLineStr = "\n"; done = false; res = '';
    while (str.length > 200) {                 
        found = false;
        for (i = 200 - 1; i >= 0; i--) {
            if (testWhite(str.charAt(i))) {
                res = res + [str.slice(0, i), newLineStr].join('');
                str = str.slice(i + 1);
                found = true;
                break;
            }
        }
        if (!found) {
            res += [str.slice(0, 200), newLineStr].join('');
            str = str.slice(200);
        }

    }

    return res + str;
    }
   
  }
</script>

<style  scoped>

 .example-3d {

	 width: 100%;
	 height: 650px;
	 padding-top: 20px;
	 padding-bottom: 10px;
}
 .swiper {
	 height: 100%;
	 width: 100%;
}

 .swiper .swiper-slide {
	 display: flex;
	 justify-content: center;
	 align-items: top;
	 width: 600px;
	 height: 600px;
	 text-align: center;
	 font-weight: bold;
	 font-size: 24;
	 background-color: #fff;
   background-image: url("../assets/images/bg.jpg");
	 background-position: center;
	 background-size: cover;
	 color: #000000;
}
 .swiper .swiper-pagination /deep/ .swiper-pagination-bullet.swiper-pagination-bullet-active {
	 background-color: #fff;
}

.card-cb .card-cb-slide {
	 display: flex;
	 justify-content: center;
	 align-items: top;
	 width: 600px;
	 height: 600px;
	 text-align: center;
	 font-weight: bold;
	 font-size: 24;
	 background-color: #fff;
   background-image: url("../assets/images/bg.jpg");
	 background-position: center;
	 background-size: cover;
	 color: #000000;
}
.number {
  position: absolute;
  margin-top:10px;
  right: 20px;
  font-size:22px;
  font-weight: bold;
  color:#000;
}
.text {
  width:500px;
  position: absolute;
  margin-top:180px;
  font-size:18px;
  color:#000;
}
.wordc1 {
  font-size:14px !important;
  color:#000;
}
.wordc2 {
  font-size:12px !important;
  color:#000;
}
.wordc3 {
  font-size:10px !important;
  color:#000;
}

.wordc4 {
  font-size:8px !important;
  color:#000;
}

.author {
  position: absolute;
  margin-top:280px;
  font-size:16px;
  color:#000;
}

.position {
  position: absolute;
  margin-top:300px;
  font-size:16px

}

.org {
 position: absolute;
 margin-top:320px;
 font-size:16px
}

.donate {
  width:400px;
 position: absolute;
 margin-top:340px;
 font-size:14px
}

.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    width: 200px;
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}




/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 599px) {
  .swiper .swiper-slide {
	 display: flex;
	 width: 300px;
	 height: 300px;
   background-image: url("../assets/images/bg300.jpg");

}
 .example-3d {
	 width: 100%;
	
    padding-top: 20px;
	 padding-bottom: 10px;
}

.number {
  position: absolute;
  margin-top:10px;
  right: 10px;
  font-size:12px;
  font-weight: bold;
  color:#000;
}
.text {
  
  width:220px;
  position: absolute;
  margin-top:50px;
  font-size:12px;
  color:#000;

}

.text p {
   line-height: normal;
  font-size:12px;
}
.wordc1 {
   line-height: normal;
  font-size:10px !important;
  color:#000;
}
.wordc2 {
   line-height: normal;
  font-size:8px !important;
  color:#000;
}
.wordc3 {
   line-height: normal;
  font-size:6px !important;
  color:#000;
}
.wordc4 {
  font-size:5px !important;
  color:#000;
}

.author {
  position: absolute;
  margin-top:150px;
  font-size:10px;
  color:#000;
}

.position {
  position: absolute;
  margin-top:160px;
  font-size:10px;
}

.org {
 position: absolute;
 margin-top:170px;
 font-size:10px;
 color:#000;
}


.donate {
    width: 220px;
 position: absolute;
 margin-top:200px;
 font-size:8px;
 color:#000;
}

.donate2 {
    width: 220px;
 position: absolute;
 margin-top:210px;
 font-size:8px;
 color:#000;
}

.donate3 {
    width: 220px;
 position: absolute;
 margin-top:220px;
 font-size:8px;
 color:#000;
}

.donate4 {
    width: 220px;
 position: absolute;
 margin-top:230px;
 font-size:8px;
 color:#000;
}

}


/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
    .swiper .swiper-slide {
	 display: flex;
	 width: 600px;
	 height: 600px;
   background-image: url("../assets/images/bg600.jpg");

}
.text {
  width:450px;
  position: absolute;
  margin-top:120px;
  font-size:16px;
}

.text p{
   line-height: normal;
   font-size:16px;
}
.wordc1 {
   line-height: normal;
  font-size:14px !important;
}
.wordc2 {
   line-height: normal;
  font-size:12px !important;
}
.wordc3 {
   line-height: normal;
  font-size:10px !important;
}

.wordc4 {
   line-height: normal;
  font-size:8px !important;
}

.author {
   line-height: normal;
  position: absolute;
  margin-top:320px;
  font-size:16px;
}

.position {
  position: absolute;
  margin-top:340px;
  font-size:16px

}

.org {
   line-height: normal;
 position: absolute;
 margin-top:360px;
 font-size:16px;
}
.donate {
  width:4000px;
 position: absolute;
 margin-top:420px;
 font-size:14px
}

.donate2 {
    width: 400px;
 position: absolute;
 margin-top:440px;
 font-size:14px
}

.donate3 {
    width: 400px;
 position: absolute;
 margin-top:460px;
 font-size:14px
}
.donate4 {
    width: 400px;
 position: absolute;
 margin-top:480px;
 font-size:14px
}
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .example {background: blue;}
} 

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .example {background: orange;}
} 

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .example {background: pink;}
}
 
</style>